<template>
  <div>
    <div class="wizard-wrap" v-if="show">
      <div class="wizard-item-wrap">
        <img
          mode="widthFix"
          style="width: 216rpx; height: 124rpx"
          src="../../assets/imgs/index-wizard/part.png"
        />
        <div class="part-con">
          <div class="part-con-circle"></div>
        </div>
        <div class="part-tips">部分时间可约</div>
      </div>
      <div class="wizard-item-wrap">
        <img
          mode="widthFix"
          style="width: 216rpx; height: 124rpx"
          src="../../assets/imgs/index-wizard/lock.png"
        />
        <div class="lock-con">
          <div class="lock-con-circle"></div>
        </div>
        <div class="lock-tips">{{h5Config.textCfg.roomName}}已锁定</div>
      </div>
      <div class="wizard-item-wrap">
        <img
          mode="widthFix"
          style="width: 216rpx; height: 124rpx"
          src="../../assets/imgs/index-wizard/all.png"
        />
        <div class="all-con">
          <div class="all-con-circle"></div>
        </div>
        <div class="all-tips">全部时间可约</div>
      </div>
      <div class="wizard-item-wrap">
        <img
          mode="widthFix"
          style="width: 216rpx; height: 124rpx"
          src="../../assets/imgs/index-wizard/disable.png"
        />
        <div class="disable-con">
          <div class="disable-con-circle"></div>
        </div>
        <div class="disable-tips">不可预约</div>
      </div>
      <div>
        <div class="i-know" @click="knowAndNotShow">我知道了</div>
      </div>
      <div>
        <van-checkbox-group
          class="redio-wrap"
          v-model="save"
          @change="checkboxChange"
        >
          <label class="radio">
            <van-checkbox name="save" checked="saveChecked" />
            <div :style="`background-color:${color};`"></div>
          </label>
          下次不再提醒
        </van-checkbox-group>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      show: false,
      save: [],
      saveSel: false,
      saveChecked: false,
      color: ''
    }
  },
  mounted () {
    this.showWizard()
  },
  computed: {
    ...mapGetters([
      'h5Config'
    ])
  },
  methods: {
    checkboxChange (detail) {
      const value = detail[0]
      this.saveSel = value
      this.color = value
    },
    knowAndNotShow () {
      api.setShowWizard(this.saveSel)
      this.show = false
    },
    showWizard () {
      const save = localStorage.getItem(common.keyShowWizard)

      if (save === 'save') {
        this.show = false
      } else {
        this.show = true
      }
    }

  }
}
</script>
<style scoped lang="scss">
/* pages/index/guard/guard.wxss */
.wizard-wrap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 3.75rem 0.625rem 0 0.625rem;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.wizard-item-wrap {
  flex-shrink: 0;
  width: 100%;
  /* height: 100%; */
  display: flex;
  align-items: center;
  margin-bottom: 0.9375rem;
}
.img-wrap {
  width: 1.6875rem;
  height: 0.9375rem;
  border-radius: 0.125rem;
}
.part-con {
  position: relative;
  display: block;
  width: 2.5rem;
  height: 0.125rem;
  margin-left: 0.625rem;
  margin-right: 1.25rem;
  background: #87f0ac;
}
.part-con-circle {
  position: absolute;
  width: 0.625rem;
  height: 0.625rem;
  top: -0.375rem;
  right: -0.8125rem;
  border-radius: 50%;
  border: 0.1875rem solid #87f0ac;
}
.part-tips {
  width: 6.9375rem;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 0.875rem;
  background: linear-gradient(126deg, #b8f5d2 0%, #89fdb0 100%);
  border-radius: 1rem;
  text-align: center;
  color: white;
}
.all-con {
  position: relative;
  display: block;
  width: 2.8125rem;
  height: 0.125rem;
  margin-left: 0.625rem;
  margin-right: 1.25rem;
  background: #8fbfff;
}
.all-con-circle {
  position: absolute;
  width: 0.625rem;
  height: 0.625rem;
  top: -0.375rem;
  right: -0.8125rem;
  border-radius: 50%;
  border: 0.1875rem solid #8fbfff;
}
.all-tips {
  width: 6.9375rem;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 0.875rem;
  background: linear-gradient(126deg, #cce2ff 0%, #8ebfff 100%);
  border-radius: 1rem;
  text-align: center;
  color: white;
}
.lock-con {
  position: relative;
  display: block;
  width: 4rem;
  height: 0.125rem;
  margin-left: 0.625rem;
  margin-right: 1.25rem;
  background: #fef278;
}
.lock-con-circle {
  position: absolute;
  width: 0.625rem;
  height: 0.625rem;
  top: -0.375rem;
  right: -0.8125rem;
  border-radius: 50%;
  border: 0.1875rem solid #fef278;
}
.lock-tips {
  width: 6.9375rem;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 0.875rem;
  background: linear-gradient(126deg, #e4e0aa 0%, #fff277 100%);
  border-radius: 1rem;
  text-align: center;
  color: white;
}
.disable-con {
  position: relative;
  display: block;
  width: 4rem;
  height: 0.125rem;
  margin-left: 0.625rem;
  margin-right: 1.25rem;
  background: #b4b4b4;
}
.disable-con-circle {
  position: absolute;
  width: 0.625rem;
  height: 0.625rem;
  top: -0.375rem;
  right: -0.8125rem;
  border-radius: 50%;
  border: 0.1875rem solid #b4b4b4;
}
.disable-tips {
  width: 6.9375rem;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 0.875rem;
  background: linear-gradient(126deg, #e0e0e0 0%, #adadad 100%);
  border-radius: 1rem;
  text-align: center;
  color: white;
}

.i-know {
  width: 6.375rem;
  height: 1.75rem;
  line-height: 1.75rem;
  text-align: center;
  border-radius: 1.375rem;
  border: 1px solid #ffffff;
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #ffffff;
  font-weight: 400;
}
.redio-wrap {
  margin-top: 0.9375rem;
  display: flex;
  font-size: 0.75rem;
  color: white;
  align-items: center;
}
.radio {
  position: relative;
  display: block;
  flex-shrink: 0;
  margin-right: 0.3125rem;
  border-radius: 50%;
  width: 1.0625rem;
  height: 1.0625rem;
  border: 1px solid white;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
checkbox {
  position: absolute;
  top: 3.125rem;
}
.checked-center {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  /* background-color: white; */
}
</style>
